import React from "react";
import { Formik, Form, Field } from "formik";
import { Grid, Button, Typography, Card, CardContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import intl from "react-intl-universal";
import { useParams, useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useMutate } from "restful-react";
import * as Yup from "yup";

import { TextField } from "components/TextField";
import { resetEmail, IResetPasswordInput, IResetPasswordResponse } from "apis";

import { FIELD_PASSWORD, FIELD_REPEAT_PASSWORD } from "./constants";
import { Urls } from "routing/urls";

const useStyles = makeStyles((theme) => ({
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(2),
  },
  marginBottom: {
    marginBottom: theme.spacing(2),
  },
  button: {
    width: "100%",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  signup: {
    display: "flex",
    justifyContent: "center",
  },
}));

const initialValues = {
  [FIELD_PASSWORD]: "",
  [FIELD_REPEAT_PASSWORD]: "",
};

export const ResetPassword = () => {
  const classes = useStyles();
  const history = useHistory();
  const { token } = useParams<{ token: string }>();
  const { enqueueSnackbar } = useSnackbar();

  const { mutate } = useMutate({
    verb: "POST",
    path: resetEmail(),
  });

  return (
    <Card>
      <CardContent>
        <div className={classes.logoContainer}>
          <Typography>
            <strong>{intl.get("RESET_PASSWORD_TITLE")}</strong>
          </Typography>
        </div>
        <Formik
          initialValues={initialValues}
          onSubmit={async (values: any) => {
            const input: IResetPasswordInput = {
              token,
              password: values[FIELD_PASSWORD],
            };
            mutate(input).then(({ errCode }: IResetPasswordResponse) => {
              if (errCode > 0) {
                enqueueSnackbar(intl.get("RESET_PASSWORD_FAILED"), {
                  variant: "error",
                });
                return;
              }
              enqueueSnackbar(intl.get("RESET_PASSWORD_SUCCESS"), {
                variant: "success",
              });
              history.push(Urls.ROOT);
            });
          }}
          validationSchema={Yup.object().shape({
            [FIELD_PASSWORD]: Yup.string().required(
              intl.get("FORM_VALIDATION_REQUIRED")
            ),
            [FIELD_REPEAT_PASSWORD]: Yup.string()
              .oneOf(
                [Yup.ref(FIELD_PASSWORD), null],
                intl.get("SEND_RESET_PASSWORD_NOT_MATCH")
              )
              .required(intl.get("FORM_VALIDATION_REQUIRED")),
          })}
        >
          {() => {
            return (
              <Form>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography>
                      <strong>{`${intl.get("RESET_FORM_PASSWORD")} *`}</strong>
                    </Typography>
                    <Field
                      component={TextField}
                      name={FIELD_PASSWORD}
                      type="password"
                      className={classes.marginBottom}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>
                      <strong>{`${intl.get(
                        "RESET_FORM_REPEAT_PASSWORD"
                      )} *`}</strong>
                    </Typography>
                    <Field
                      component={TextField}
                      name={FIELD_REPEAT_PASSWORD}
                      type="password"
                      className={classes.marginBottom}
                    />
                  </Grid>
                  <Button
                    type="submit"
                    className={classes.button}
                    variant="contained"
                    color="secondary"
                    size="large"
                  >
                    {intl.get("RESET_FORM_SUBMIT")}
                  </Button>
                </Grid>
              </Form>
            );
          }}
        </Formik>
      </CardContent>
    </Card>
  );
};
